<template>
  <UnloggedLayout>
    <FormContainer>
      <BankAccountForm
        v-if="!busy"
        ref="jbcredBankAccountForm"
        :data="cptdCurrentForm['bank_account'] || {}"
        :allowed-bank-codes="PartnerBankCodesAllowed.JBCRED"
        :account-type-options="accountTypeOptions"
        title="Conta para depósito do empréstimo"
        @submit="submit"
      />
    </FormContainer>
  </UnloggedLayout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import FormContainer from '~/containers/forms/FormContainer.vue'
import UnloggedLayout from '@/layouts/UnloggedLayout.vue'
import BankAccountForm from '~/components/forms/payment/BankAccountForm.vue'
import { PartnerBankCodesAllowed } from '~/helpers/partners/common'
import { Partner } from '~/data/common'
export default {
  name: 'DynamicFormPage',
  components: {
    BankAccountForm,
    UnloggedLayout,
    FormContainer,
  },
  data() {
    return {
      busy: false,
      formId: 'JBCRED',
      accountTypeOptions: [
        {
          label: 'Conta Corrente',
          value: 'CHECKING',
          id: 'CHECKING',
        },
        {
          label: 'Conta Poupança',
          value: 'SAVING',
          id: 'SAVING',
          disabled: true,
          options: {
            badge: {
              type: 'negative',
              label: 'Não é aceito',
            },
          },
        },
      ],
    }
  },
  computed: {
    PartnerBankCodesAllowed() {
      return PartnerBankCodesAllowed
    },
    ...mapGetters({
      gtDynamicForms: 'dynamic-forms/gtDynamicForms',
      gtNoCollateralOfferSelected:
        'products/loans/no-collateral/no-collateral/gtNoCollateralOfferSelected',
      gtUser: 'user/user/gtUser',
      personaData: 'user/persona/personaData',
    }),
    cptdCurrentForm() {
      return this.gtDynamicForms[this.formId] || {}
    },
  },
  created() {
    this.actSetupForm(this.formId)
    if (!this.gtNoCollateralOfferSelected || !this.gtUser) {
      this.$router.push({
        path: '/ofertas',
      })
    }
    if (
      PartnerBankCodesAllowed[Partner.JBCRED].includes(
        this.personaData?.finance?.account?.bank,
      )
    ) {
      this.submit(this.personaData.finance.account)
    }
  },
  methods: {
    ...mapActions({
      actUpdateForm: 'dynamic-forms/actUpdateForm',
      actSetupForm: 'dynamic-forms/actSetupForm',
    }),
    async submit(data) {
      this.actUpdateForm({
        formId: this.formId,
        key: 'bank_account',
        value: data,
      })
      this.actUpdateForm({
        formId: this.formId,
        key: 'bank_checking_account_digit',
        value: data.number[data.number.length - 1],
      })

      this.$router.push({
        path: '/forms/emprestimo/sem-garantia/parceiros/jbcred/selecionar-oferta/expedicao-rg',
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
